export enum WorkTypes {
  Normal = 0,
  Overtime = 1,
  Other = 2
}
  
export enum WorksheetClassification {
  Mine = 'Mine',
  Shared = 'Shared',
  ResponsibleFor = 'ResponsibleFor',
  All = 'All',
  MineCompleted = 'MineCompleted'
}
  
export enum ApiWorksheetClassification {
  Mine,
  Shared,
  ResponsibleFor,
  All
}
  
// this is the one that is used in all API calls
export enum WorksheetStatus {
  NotStarted = 0,
  InProgress = 1,
  PartiallyCompleted = 2,
  Completed = 3,
  Closed = 4,
  Exported = 5
}
  
export type WorksheetStatusString = keyof typeof WorksheetStatus;
  
// this is the one that is used when displaying the status with colors
export enum WorkflowStatus {
  NotDefined = 0,
  InProgress = 1,
  PartiallyCompleted = 2,
  PartiallyCompletedWithAppointment = 3,
  Completed = 4,
  Closed = 5,
  NotStarted = 6
}
  
export type WorkflowStatusString = keyof typeof WorkflowStatus;
  
export enum ReadCalendarEventAccessLevel {
  Self,
  Teamlead,
  All
}